<div class="container">
  <div #flightlist id="flightlist" class="flight-list-container">
    <div class="toolbar-container">
      <div class="toolbar">
        <div class="title">
          <div class="pi pi-sync sync-icon" (click)="onRefreshClicked()"></div>
          <div class="lastupdate-text">Updated:
            <div *ngIf="lastUpdated else skeleton">
              {{lastUpdated}}
            </div>
          </div>
          <ng-template #skeleton>
            <p-skeleton width="30px" height="17px"></p-skeleton>
          </ng-template>
        </div>
        <div class="icon-container">
          <div class="row">
            <i class="sort-icon {{appSettings.sortOrder === 0 ? 'pi pi-arrow-up' : 'pi pi-arrow-down'}}"></i>
            <div [ngClass]="{'flt-filter-icon': (appSettings.filter.flights), 
                'filter-icon-inactive': (!appSettings.filter.flights)}">F</div>
            <div [ngClass]="{'dh-filter-icon': (appSettings.filter.deadhead), 
                'filter-icon-inactive': (!appSettings.filter.deadhead)}">D</div>
            <div [ngClass]="{'cx-filter-icon': (appSettings.filter.cancelled), 
                'filter-icon-inactive': (!appSettings.filter.cancelled)}">C</div>
          </div>
          <i class="bi-filter filter-icon" (click)="onFilterClicked()"></i>
          <i class="pi pi-question-circle help-icon" (click)="onHelpClicked()"></i>
        </div>
      </div>
    </div>
    <div class="paging-container">
      <div class="paging">
        <div class="button-row">
          <button class="chevron-btn pi pi-angle-left" (click)="getPrevPeriod()">
          </button>
          <p-calendar #calendar class="calendar" (onSelect)="dateInputEvent($event)" [(ngModel)]="date" [showIcon]="false"
            [touchUI]="true" dateFormat="MM yy" view="month" [readonlyInput]="true" appendTo="body">
            <p-footer>
              <div class="buttonbar">
                <button class="cal-button" type="button" (click)="onTodayClick()">Now</button>
                <button class="cal-button" type="button" (click)="onDoneClick()">Done</button>
              </div>
            </p-footer>
          </p-calendar>
          <button class="chevron-btn pi pi-angle-right" (click)="getNextPeriod()" [disabled]="dateIsNow()">
          </button>
        </div>
      </div>
    </div>
    <div class="flight-list-container">
      <div class="flight-list-content" #scroll>
        <div *ngIf="activityRecordList$ | async as activityRecordList">
          @if(activityRecordList.sequences.length != 0) {
          <div *ngFor="let sequence of activityRecordList.sequences, let i = index">
            <div (click)="onSequenceClicked(sequence, i,  'sequence-detail')" class="header-title">
              {{ sequence.sequenceNumber }}
            </div>
            <div *ngFor="let duty of sequence.dutyPeriodSummaries">
              <div #leg class="leg" *ngFor="let leg of duty.legs; let i = index">
                <app-flight-item (click)="onLegClicked(leg, sequence, 'flight-detail')"
                  [isTimeFormatUTC]="isTimeFormatUTC" [flightNumber]="leg.flightNumber" [aircraft]="leg.aircraft"
                  [depStation]="leg.departureStation.code" [arrStation]="leg.arrivalStation.code"
                  [depTimes]="leg.departure" [arrTimes]="leg.arrival" [flightTimeActual]="leg.flightTimeActual"
                  [flightTimeScheduled]="leg.flightTimeScheduled" [isDeadhead]="leg.isDeadhead"
                  [isCancelled]="leg.isCancelled">
                </app-flight-item>
              </div>
            </div>
          </div>
          }
          @else {
          <div>
            <div class="no-flights">
              No Flights Found</div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>